import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'material-ui/Card';
import DialogStore from '../../stores/DialogStore';
import { Container } from 'flux/utils';

export const asCard = (Component) => ({cardType, ...props}) => {
    const className = (cardType ? `cent-card cent-card-${cardType}` : 'cent-card');
    return (
        <Card className={className} >
            <Component {...props} />
        </Card>
    );
};

asCard.propTypes = {
    cardType: PropTypes.string
};

// TODO: cleaner fallthrough
export const withMyUserId = (Component, options = {}) => {
    const { asFallback = false } = options;
    const myComponent = ({userId = null, ...props} = {}, {auth}) => <Component {...props} userId={ (asFallback && !!userId ? userId : auth.identity.id) } />;
    myComponent.contextTypes = {
        auth: PropTypes.object
    };

    return myComponent;
};

export const withId = (Component, getId = ({routeParams}) => ({id: Number(routeParams.id) || null})) =>
    (props = {}) => <Component {...getId(props)} {...props} />;

export const asDialog = (Component, dialogType) => {
    class Dialog extends React.Component {
        render() {
            if (!!dialogType && this.state.open !== dialogType) { return null; }
            return (<Component {...this.props} {...this.state} />);
        }
    }

    Dialog.getStores = () => ([DialogStore]);
    Dialog.calculateState = (prevState) => ({
        ...DialogStore.getState()
    });

    return Container.create(Dialog);
};

export const withValidation = (Component, validation, getData = ({draft}) => draft) => (props) => <Component {...props} errors={validation(getData(props)) } />;

